// Per-hostname branding for the SHELL (pre-login) UI — sidebar logo,
// login page logo, browser tab title, favicon. After login, the
// BrandingContext loads the per-org overrides on top of this.
//
// To add another white-label, append an entry to BRANDS keyed by the
// subdomain prefix. The asset paths must exist under public/ so they
// resolve at /<asset> when served by webpack-dev-server or nginx.

// Shared Ador AI config — used by both `adorai.roadvision.ai` and the
// partner domain `nhai-das.adortraffictech.com` that fronts the same app.
const ADOR_BRAND = {
  name: 'Ador AI',
  logo: '/Ador_logo/Ador_logo.png',
  logoCollapsed: '/Ador_logo/Ador_logo.png',
  favicon: '/Ador_logo/adorfavicon.ico',
  logoHeightSm: 'h-10',
  logoHeightLg: 'h-16',
};

const BRANDS = {
  adorai: ADOR_BRAND,
  // CNAME partner: nhai-das.adortraffictech.com → adorai.roadvision.ai →
  // this VM. Keyed by the leading sub-domain label.
  'nhai-das': ADOR_BRAND,
  // Default (any subdomain that doesn't match above) — Saptagon look.
  default: {
    name: 'Saptagon',
    logo: '/logo1.saptagon.png',   // original full lockup (wordmark + taglines) — login/signup panels + form card
    logoSidebar: '/logo1.saptagon.wordmark.png',   // cropped wordmark — expanded sidebar only
    logoCollapsed: '/faviconSaptagon-9.png',
    favicon: '/faviconSaptagon.ico',
    logoHeightSm: 'h-16',
    logoHeightLg: 'h-20',
  },
};

function pickBrand() {
  if (typeof window === 'undefined') return BRANDS.default;
  const host = window.location.hostname.toLowerCase();
  // Match the leading sub-domain label (e.g. "adorai" in "adorai.roadvision.ai").
  // Anything else (gis., localhost, IP literal) → default.
  const sub = host.split('.')[0];
  return BRANDS[sub] || BRANDS.default;
}

export const BRAND = pickBrand();
